import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'orderform-cvc-dialog',
  templateUrl: './cvc-dialog.component.html',
  styleUrls: ['./cvc-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CvcDialogComponent implements OnInit {
  visible$ = new Subject<boolean>();

  constructor() {}

  ngOnInit(): void {}

  open() {
    this.visible$.next(true);
  }

  close() {
    this.visible$.next(false);
  }
}
